module.exports = __webpack_public_path__ + "static/img/notext-starpick.85856e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-starpick.png
// module id = dixW
// module chunks = 1